<button mat-button cm-mini-button class="column-filter-button" type="button" [matMenuTriggerFor]="searchableColumnMenu"
	(menuOpened)="focusFirstItem()" [matTooltip]="filterButtonTooltip$ | async">
	<ats-icon *ngIf="(isFiltered$ | async); else notFiltered" name="filter"></ats-icon>
	<ng-template #notFiltered>
		<ats-icon name="filter-closed"></ats-icon>
	</ng-template>
</button>

<mat-menu #searchableColumnMenu="matMenu">
	<button #firstMenuItem mat-menu-item (click)="toggleColumnSearch(null)" [attr.aria-checked]="!(isFiltered$ | async)"
		role="menuitemradio">
		<span class="menu-item">
			<ats-icon name="circle" *ngIf="isFiltered$ | async; else circleChecked"></ats-icon>
			<span class="menu-item__text" cmLocalize="Core/System.Table.MenuItem.ClearSearchColumn">
				All Columns
			</span>
		</span>
	</button>
	<button *ngFor="let col of columns$ | async" mat-menu-item (click)="toggleColumnSearch(col.field)"
		[attr.aria-checked]="col.selected" role="menuitemradio">
		<span class="menu-item">
			<ats-icon name="circle" *ngIf="!col.selected; else circleChecked"></ats-icon>
			<span class="menu-item__text">
				{{ col.label | cmLocalize: col.localizationKey}}
			</span>
		</span>
	</button>
</mat-menu>

<form [formGroup]="form">
	<mat-form-field>
		<mat-label>
			<span cmLocalize="Core/System.Table.Label.Search">Search</span>
		</mat-label>
		<input matInput type="text" formControlName="search">
		<ats-icon name="search" matPrefix></ats-icon>
		<button mat-button cm-mini-button matSuffix type="button" *ngIf="search.value" (click)="search.setValue('')"
			[matTooltip]="'Clear' | cmLocalize: 'Core/System.Table.Button.ClearSearch'"
			[attr.aria-label]="'Clear' | cmLocalize: 'Core/System.Table.Button.ClearSearch'">
			<ats-icon name="close"></ats-icon>
		</button>
	</mat-form-field>
</form>

<ng-template #circleChecked>
	<ats-icon name="circle-check"></ats-icon>
</ng-template>
